import ProfilePicture from "../common/ProfilePicture";
import EmployeeDocuments from "../document/EmployeeDocuments";
import { Button, Descriptions, Flex, Popconfirm, Space, Tabs } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate, useRevalidator, useRouteLoaderData } from "react-router";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";
import { date2locale, downloadFile } from "../common/common";
import { IdCard } from "lucide-react";

export default function Employee() {
  const employee = useRouteLoaderData("employee");
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  return (
    <div>
      <BackTitle
        backEnabled={false}
        title={employee.fullName}
        secondary={`ID: ${employee.id}`}
        extra={
          <Space>
            <Button icon={<EditOutlined />} onClick={() => navigate("edit")}>
              Modifica
            </Button>
            <Popconfirm
              title="Eliminare questo dipendente?"
              okText="Elimina"
              cancelText="Annulla"
              onConfirm={() => api.employee.delete(employee.id).then(() => navigate("/employees"))}
            >
              <Button danger icon={<DeleteOutlined />}>
                Elimina
              </Button>
            </Popconfirm>
          </Space>
        }
      />
      <Flex orientation={"horizontal"} gap={64}>
        <Flex orientation={"vertical"} gap={24}>
          <ProfilePicture
            key={employee.id}
            employeeId={employee.id}
            pictureRef={employee.pictureRef}
            onUploaded={() => revalidator.revalidate()}
          />
          <Button
            onClick={() => downloadFile(`employee/${employee.id}/badge`)}
            icon={<IdCard size={16} />}
          >
            Stampa tesserino
          </Button>
        </Flex>
        <Descriptions
          style={{ flex: 1 }}
          column={2}
          layout="vertical"
          items={[
            { key: "lastName", label: "Cognome", children: employee.lastName },
            { key: "firstName", label: "Nome", children: employee.firstName },
            { key: "fiscalCode", label: "Codice fiscale", children: employee.fiscalCode },
            { key: "badgeId", label: "Badge", children: employee.badgeId ?? "—" },
            { key: "mansion", label: "Mansione", children: employee.mansion?.name ?? "—" },
            {
              key: "validFrom",
              label: "Valido dal",
              children: employee.validFrom ? date2locale(employee.validFrom) : "—",
            },
            {
              key: "validUntil",
              label: "Valido al",
              children: employee.validUntil ? date2locale(employee.validUntil) : "—",
            },
          ]}
        />
      </Flex>
      <Tabs
        size={"large"}
        items={[
          {
            key: "documents",
            label: "Documenti",
            children: <EmployeeDocuments key={employee.id} employeeId={employee.id} />,
          },
        ]}
      />
    </div>
  );
}
